import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      // Navigation
      nav: {
        dashboard: 'Dashboard',
        customers: 'Clientes',
        products: 'Productos',
        orders: 'Pedidos',
        inventory: 'Inventario',
        productionPlan: 'Plan de Cosecha',
        reports: 'Reportes',
        settings: 'Configuración'
      },
      
      // Common
      common: {
        search: 'Buscar',
        filter: 'Filtrar',
        clear: 'Limpiar',
        add: 'Agregar',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        loading: 'Cargando...',
        noData: 'No hay datos disponibles',
        actions: 'Acciones',
        status: 'Estado',
        type: 'Tipo',
        priority: 'Prioridad',
        date: 'Fecha',
        total: 'Total',
        all: 'Todos'
      },
      
      // Customers
      customers: {
        title: 'Gestión de Clientes',
        subtitle: 'Administra la información de tus clientes de exportación',
        name: 'Nombre',
        contact: 'Contacto',
        email: 'Email',
        phone: 'Teléfono',
        country: 'País',
        state: 'Estado/Región',
        city: 'Ciudad',
        address: 'Dirección',
        zipCode: 'Código Postal',
        creditLimit: 'Límite de Crédito',
        paymentTerms: 'Términos de Pago',
        lastOrder: 'Último Pedido',
        createdAt: 'Fecha de Creación',
        status: {
          active: 'Activo',
          inactive: 'Inactivo'
        },
        type: {
          wholesaler: 'Mayorista',
          distributor: 'Distribuidor',
          importer: 'Importador'
        }
      },
      
      // Products
      products: {
        title: 'Catálogo de Productos',
        subtitle: 'Gestiona tu inventario de ruscus para exportación',
        sku: 'SKU',
        name: 'Nombre',
        category: 'Categoría',
        length: 'Largo (cm)',
        grade: 'Calidad',
        description: 'Descripción',
        unitPrice: 'Precio Unitario',
        packingUnit: 'Unidad de Empaque',
        unitsPerBox: 'Unidades por Caja',
        boxType: 'Tipo de Caja',
        weight: 'Peso (kg)',
        seasonality: 'Temporalidad',
        origin: 'Origen',
        harvestTime: 'Tiempo de Cosecha',
        shelfLife: 'Vida Útil',
        gradeTypes: {
          standard: 'Estándar',
          premium: 'Premium'
        }
      },

      // Inventory
      inventory: {
        title: 'Inventario Disponible',
        subtitle: 'Visualiza el stock actual por producto y ubicación',
        searchPlaceholder: 'Buscar por producto, código o nota...',
        totalStock: 'Stock Total',
        lastEntry: 'Último Ingreso',
        summary: 'Resumen de Inventario',
        location: 'Ubicación',
        entryDate: 'Última Actualización',
        quantity: 'Cantidad',
        inTransit: 'En Tránsito',
        planned: 'Planificado',
        inTransitPlanned: 'En Tránsito/Planificado',
        product: 'Producto',
        code: 'Código',
        notes: 'Observaciones',
        filterByLocation: 'Filtrar por ubicación',
        noData: 'No hay stock disponible',
        lastUpdatedAt: 'Última actualización',
        locationAll: 'Todas',
        locationHuerta: 'Campo',
        locationWarehouse: 'Warehouse USA',
        locationAllDescription: 'Ver stock en todas las ubicaciones',
        locationHuertaDescription: 'Stock disponible directamente en el campo',
        locationWarehouseDescription: 'Stock listo para despacho desde bodega en USA',
        addStock: 'Agregar/Rebajar',
        addStockTitle: 'Agregar Nuevo Stock',
        editStockTitle: 'Editar Stock',
        selectProduct: 'Seleccionar producto',
        selectLocation: 'Seleccionar ubicación',
        enterQuantity: 'Ingresar cantidad',
        addSuccess: 'Stock agregado exitosamente',
        addError: 'Error al agregar stock',
        updateSuccess: 'Stock actualizado exitosamente',
        updateError: 'Error al actualizar stock',
        deleteSuccess: 'Stock eliminado exitosamente',
        deleteError: 'Error al eliminar stock',
        deleteConfirm: '¿Estás seguro de que deseas eliminar este registro de inventario?',
        actions: 'Acciones',
        addInventoryTitle: 'Agregar Inventario',
        reduceInventoryTitle: 'Rebajar Inventario',
        eventDate: 'Fecha',
        eventTime: 'Hora',
        addButton: 'Agregar',
        reduceButton: 'Rebajar',
        reduceSaleButton: 'Rebajar Venta',
        reduceLossButton: 'Rebajar Merma',
        reduceType: 'Tipo de Rebaja',
        sale: 'Venta',
        loss: 'Merma',
        history: 'Historial',
        historyTitle: 'Historial de Inventario',
        historySubtitle: 'Visualiza los movimientos de inventario y estadísticas',
        filters: 'Filtros',
        clearFilters: 'Limpiar filtros',
        totalAdded: 'Total Agregado',
        totalReduced: 'Total Rebajado',
        totalEvents: 'Total Eventos',
        movementsByDay: 'Movimientos por Día',
        topProducts: 'Top 10 Productos (Movimiento Neto)',
        eventDistribution: 'Distribución de Eventos',
        eventDetails: 'Detalle de Eventos',
        added: 'Agregado',
        reduced: 'Rebajado',
        noEventsInPeriod: 'No hay eventos en el período seleccionado',
        loadingEvents: 'Cargando eventos...',
        from: 'Desde',
        to: 'Hasta'
      },

      // Orders
      orders: {
        title: 'Pedidos Semanales',
        subtitle: 'Gestiona los pedidos de exportación por semana',
        orderNumber: 'Número de pedido',
        deliveryDate: 'Fecha de Entrega',
        deliveryWeek: 'Semana de Entrega',
        deliveryId: 'ID de Entrega',
        orderDate: 'Fecha de Pedido',
        totalAmount: 'Monto Total',
        currency: 'Moneda',
        notes: 'Notas',
        items: 'Productos',
        quantity: 'Cantidad',
        unitPrice: 'Precio Unitario',
        totalPrice: 'Precio Total',
        currentWeek: 'Semana Actual',
        weekOf: 'Semana del',
        summary: 'Resumen',
        totalOrders: 'Total de Pedidos',
        weeklyTotal: 'Total Semanal',
        productsSummary: 'Resumen de Productos',
        productsSummarySubtitle: 'Productos consolidados de todos los pedidos',
        totalBoxes: 'Total Cajas',
        noProducts: 'No hay productos en los pedidos de esta semana',
        type: {
          recurring: 'Recurrente',
          spot: 'Puntual'
        },
        status: {
          pending: 'Pendiente',
          confirmed: 'Confirmado',
          inProduction: 'En Producción',
          scheduled: 'Programado',
          shipped: 'Enviado',
          delivered: 'Entregado',
          cancelled: 'Cancelado'
        },
        priority: {
          high: 'Alta',
          medium: 'Media',
          low: 'Baja'
        }
      },
      
      // Dashboard
      dashboard: {
        title: 'Dashboard - Patagonia Vital',
        subtitle: 'Resumen de operaciones de exportación',
        welcome: 'Bienvenido al Sistema de Gestión',
        quickStats: 'Estadísticas Rápidas',
        recentActivity: 'Actividad Reciente',
        weeklyOverview: 'Resumen Semanal'
      },

      // Plan de Cosecha
      planProduction: {
        title: 'Plan de Cosecha',
        subtitle: 'Organiza la cosecha semanal por producto',
        noSeasonSelected: 'Selecciona una temporada y semana para visualizar el plan.',
        createButton: 'Crear plan de cosecha',
        noPlan: 'No existe plan de cosecha para la semana seleccionada.',
        addProduct: 'Agregar Producto',
        addProductTitle: 'Agregar Producto al Plan',
        editProductTitle: 'Editar Producto',
        selectProductPlaceholder: 'Seleccionar producto',
        enterPlannedQuantity: 'Ingrese cantidad planificada',
        emptyRows: 'No hay productos asignados en el plan.',
        table: {
          product: 'Producto',
          inventarioCampo: 'I. Campo',
          inventarioWarehouse: 'I. Warehouse USA',
          orders: 'Pedidos',
          planned: 'Planificado',
          faltante: 'Faltante'
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
